import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageInitialContent,
  defaultPageProperties,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
  metadataValidations,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("ImagesSlide", {
  title: "Image Slide",
  attributes: {
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: [
    ...defaultPageProperties,
    "smallHeader",
    "targetLink",
    "images",
    "backgroundImage",
  ],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: ["body", "sortKey"],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
  validations: [...metadataValidations],
});
